import { connect, MapStateToProps } from 'react-redux';
import { Props } from './SubscriptionCenter';
import { AppState } from '../../../../types/store';
import {
  getSubscriptionsStats,
  getSubscriptionsChartData,
} from '../../../selectors/subscriptionsSection';

export type StateProps = Pick<Props, 'stats' | 'chartData'>;
export type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> =
  state => ({
    stats: getSubscriptionsStats(state),
    chartData: getSubscriptionsChartData(state),
  });

export default connect(mapStateToProps);
